import { render, staticRenderFns } from "./Zjgw.vue?vue&type=template&id=599aa0be&scoped=true&"
import script from "./Zjgw.vue?vue&type=script&lang=js&"
export * from "./Zjgw.vue?vue&type=script&lang=js&"
import style0 from "./Zjgw.vue?vue&type=style&index=0&id=599aa0be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599aa0be",
  null
  
)

export default component.exports